import React from 'react';
import { useSelector } from 'react-redux';
import { isNumber } from 'lodash';
import conceptualLabelSelectors from '../../../store/selectors/conceptual-label.selectors';
import EditConceptualLabelDrawer from '../../../pages/resources/conceptual-labels/forms/edit/EditConceptualLabelDrawer';

/**
 * GlobalModals component that renders all global modals and drawers that can be opened from anywhere in the app
 * based on Redux state.
 */
const GlobalModals = () => {
  const editingConceptualLabelId = useSelector(conceptualLabelSelectors.editingConceptualLabelId);

  return (
    <>
      {isNumber(editingConceptualLabelId) && <EditConceptualLabelDrawer />}
    </>
  );
};

export default GlobalModals; 